import React from 'react';

import { PrimaryFilters as PrimaryFiltersProvider } from 'components/Filters';

import { FILTER_EVENTS, FILTER_APPLICATIONS } from 'scenes/Events/constants';

import Filters from './filters';

export const PRIMARY_FILTERS = [FILTER_EVENTS, FILTER_APPLICATIONS];

const PrimaryFilters = () => (
  <PrimaryFiltersProvider primary={PRIMARY_FILTERS}>
    <Filters.Applications withClear={true} />
    <Filters.Events withClear={true} />
  </PrimaryFiltersProvider>
);

export default PrimaryFilters;
